import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import {
  loadReactComponent,
  loadReactControlsComponent,
} from 'src/components/YandexMap/loaders/componentLoaders';
import FullscreenControlButton from './components/FullscreenControlButton';

const YMapControls = loadReactComponent('YMapControls', loadModulePromise);

const YMapZoomControl = loadReactControlsComponent(
  'YMapZoomControl',
  loadModulePromise,
);

type ControlProps = {
  isMobile: boolean;
  onExpand?: () => void;
};

const Controls = (props: ControlProps) => {
  const { isMobile = false, onExpand } = props;

  return (
    <>
      <YMapControls position={isMobile ? 'left' : 'top left'}>
        <YMapZoomControl />
      </YMapControls>
      {isMobile && onExpand && (
        <YMapControls position="bottom right">
          <FullscreenControlButton
            isExpanded={false}
            toggleHandler={onExpand}
          />
        </YMapControls>
      )}
    </>
  );
};

export default Controls;
